"use client";

import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingFEEnableLISPNextPagePrefetchingBugFix } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingFEEnableLISPNextPagePrefetchingBugFix";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { MaybeWhenVisibilityIsImminent } from "@faire/deprecated-retailer-visitor-shared/views/brand/__internal__/MaybeWhenVisibilityIsImminent";
import { SearchPageFooterPlaceholder } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/loggedInSearchLoadingSkeleton";
import { LazySearchPageFooterBase } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageFooter/index";
import { useSearchPageNonPrimaryContentDeferRender } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPagePerformanceTrackingWrapper";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import React, { Suspense } from "react";

export const SearchPageFooter = () => {
  useTraceComponentRender("LazySearchPageFooter");

  useSearchPageNonPrimaryContentDeferRender();
  const shouldDeferRender = useIsLoggedInRetailer();

  const enableNextPagePrefetchBugFix =
    useSettingFEEnableLISPNextPagePrefetchingBugFix();

  // We need WhenVisibilityIsImminent to prevent prefetching before the component is visible
  return (
    <MaybeWhenVisibilityIsImminent
      customizePlaceholder={<SearchPageFooterPlaceholder />}
      shouldWrap={!shouldDeferRender || enableNextPagePrefetchBugFix}
    >
      <Suspense>
        <LazySearchPageFooterBase />
      </Suspense>
    </MaybeWhenVisibilityIsImminent>
  );
};
